module.exports = __webpack_public_path__ + "static/img/guest18.917c00b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/guest18.png
// module id = C9Xi
// module chunks = 0